import Vue from 'vue'
import VueRouter, { Route } from 'vue-router'
import { routers } from './router'
import util from '../lib/util'
import oidc from '@/lib/oidc'
import app from '@/lib/app'
// import NProgress from 'nprogress'

Vue.use(VueRouter)

export const router = new VueRouter({
	mode: 'history',
	routes: routers
})

router.beforeEach((to: Route, from: Route, next: any) => {
	// NProgress.start()
	util.title(to.meta.title)

	if (!to.meta.allowAnonymous) {
		// 验证是否授权，如果未授权则跳转到登录页
		if (oidc.isAuthorization()) {
			// 如果是从其它页面跳转过来，则取消跳转
			// 如果是从空的地址栏直接输入的地址，则跳转到首页
			// if (to.meta && to.meta.permission) {
			// 	router.app.$nextTick(async () => {
			// 		let permissions: Array<string> = router.app.$store.state.permission.currentUserPermissionKeys
			// 		if (permissions.length === 0)
			// 			permissions = await router.app.$store.dispatch('permission/getCurrentUserPermissionKeys')
			// 		let hasPermission = permissions.findIndex(t => t.toLowerCase() === to.meta.permission.toLowerCase()) > -1
			// 		// 有指定的权限则继续，否则终止路由跳转
			// 		if (hasPermission)
			// 			next()
			// 		else {
			// 			// 如果是从其它页面跳转过来，则取消跳转
			// 			// 如果是从空的地址栏直接输入的地址，则跳转到首页
			// 			if (from) {
			// 				next(false)
			// 			} else {
			// 				next({ path: '/' })
			// 			}
			// 		}
			// 	})
			// } else {
			// 	next()
			// }
			next()
		} else {
			if (app.isProduction())
				next({ name: 'auth' })
			else
				next({ name: 'login' })
			// next({ name: 'auth' })
		}
	} else {
		next()
	}

	// let userInfo = app.getUserInfo()
	// if(!userInfo && to.name !== 'login' && to.name !== 'authenticate' && to.name !== 'register') {
	// 	next({name: 'authenticate'})
	// } else {
	// 	next()
	// }

	// let tocken = Util.getToken()
	// if(tocken || (!tocken && to.name === 'login')) {
	// 	next()
	// 	// if(to.name && app.auth.hasPermission(to.name))
	// 	// 	next()
	// 	// else {
	// 	// 	console.log(to)
	// 	// 	// 终止导航
	// 	// 	next(false)
	// 	// }
	// } else {
	// 	next({
	// 		name: 'login',
	// 		query: { redirect: to.path}
	// 	})
	// }
})
router.afterEach((to: Route) => {
	// Util.openNewPage(router.app, to.name, to.params, to.query);
	// 设置菜单的激活状态
	// const route = Util.getRouterObjByName(routers, to.name)
	// if(route)
	// 	router.app.$store.commit('setActiveMenu', to.path)
	// NProgress.done()
	window.scrollTo(0, 0)
})
